import { DataService } from "./dataService";

const PickUpServices = {
  getPickUpList: async (data) => {
    return DataService.get("/admin/pickup_list", data);
  },

  getPickUpDetails: async (data) => {
    return DataService.get("/admin/get_pickup_details", data);
  },

  setPickUpDetails: async (data) => {
    return DataService.post("/admin/update_pickup_details", data);
  },

  getPickUpListExport: async (data) => {
    return DataService.get("/admin/export/pickup_list", data);
  },
};

export default PickUpServices;
